package com.example.mystybag.cropImage.model

import com.example.mystybag.sharedmodels.SCImage

data class ProfileImageCropperUIState(
    var selectedImage       : SCImage?          = null,
    var cropImage           : Boolean           = false,
    var rotateImage         : Boolean           = false,
    var aspectRatio         : Float?            = null, // null = square (1:1), otherwise width/height ratio
    var outputWidth         : Int?              = null,
    var outputHeight        : Int?              = null,
)
